import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { TaxRegistration } from "@/gql/graphql";

export function TaxRegistrationInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  return (
    <SelectInput
      options={[
        {
          label: "Not Registered",
          options: [{ label: "None", value: TaxRegistration.None }],
        },
        {
          label: "Australia & New Zealand",
          options: [
            { label: "GST (Australia)", value: TaxRegistration.GstAu },
            { label: "GST (New Zealand)", value: TaxRegistration.GstNz },
          ],
        },
        {
          label: "Canada",
          options: [
            { label: "GST (Canada)", value: TaxRegistration.GstCa },
            { label: "HST (Canada)", value: TaxRegistration.HstCa },
          ],
        },
        {
          label: "European Union VAT",
          options: [
            { label: "VAT (Austria)", value: TaxRegistration.VatAt },
            { label: "VAT (Belgium)", value: TaxRegistration.VatBe },
            { label: "VAT (Bulgaria)", value: TaxRegistration.VatBg },
            { label: "VAT (Croatia)", value: TaxRegistration.VatHr },
            { label: "VAT (Cyprus)", value: TaxRegistration.VatCy },
            { label: "VAT (Czech Republic)", value: TaxRegistration.VatCz },
            { label: "VAT (Denmark)", value: TaxRegistration.VatDk },
            { label: "VAT (Estonia)", value: TaxRegistration.VatEe },
            { label: "VAT (Finland)", value: TaxRegistration.VatFi },
            { label: "VAT (France)", value: TaxRegistration.VatFr },
            { label: "VAT (Germany)", value: TaxRegistration.VatDe },
            { label: "VAT (Greece)", value: TaxRegistration.VatGr },
            { label: "VAT (Hungary)", value: TaxRegistration.VatHu },
            { label: "VAT (Ireland)", value: TaxRegistration.VatIe },
            { label: "VAT (Italy)", value: TaxRegistration.VatIt },
            { label: "VAT (Latvia)", value: TaxRegistration.VatLv },
            { label: "VAT (Lithuania)", value: TaxRegistration.VatLt },
            { label: "VAT (Luxembourg)", value: TaxRegistration.VatLu },
            { label: "VAT (Malta)", value: TaxRegistration.VatMt },
            { label: "VAT (Netherlands)", value: TaxRegistration.VatNl },
            { label: "VAT (Poland)", value: TaxRegistration.VatPl },
            { label: "VAT (Portugal)", value: TaxRegistration.VatPt },
            { label: "VAT (Romania)", value: TaxRegistration.VatRo },
            { label: "VAT (Slovakia)", value: TaxRegistration.VatSk },
            { label: "VAT (Slovenia)", value: TaxRegistration.VatSi },
            { label: "VAT (Spain)", value: TaxRegistration.VatEs },
            { label: "VAT (Sweden)", value: TaxRegistration.VatSe },
          ],
        },
      ]}
      {...props}
    />
  );
}
